import { render } from "./Orders.vue?vue&type=template&id=325bbf8d"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"
script.render = render

export default script